// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".client-filter-content[data-v-684964e4]{padding:8px 0}", ""]);
// Exports
module.exports = exports;
